<template>
  <div class="sidebar">
    <ul class="main-menu">
      <li class="main-list">
        <h2 class="list-header pdt0">
          License
          <i class="fas fa-caret-down"></i>
        </h2>
        <ul class="sub-menu">
          <li>
            <a href="https://mtradeasia.com/main/msb-license/" target="_blank">Money Service Business License</a>
          </li>
        </ul>
      </li>

      <li class="main-list">
        <h2 class="list-header">
          Terms & Conditions
          <i class="fas fa-caret-down"></i>
        </h2>
        <ul class="sub-menu">
          <li>
            <router-link :to="'/privacy/personal'">Personal Payments Terms & Conditions</router-link>

            <!-- <a href="" class="active">Personal Payments Terms & Conditions</a> -->
          </li>
          <li>
            <router-link :to="'/privacy/business'">Business Payments Terms & Conditions</router-link>
            <!-- <a href="">Business Payments Terms & Conditions</a> -->
          </li>
          <li>
            <router-link :to="'/privacy/promotions'">Promotions</router-link>
            <!-- <a href="">Business Payments Terms & Conditions</a> -->
          </li>
          <!-- <li>
                        <a href="javascript:void(0)">Moneygram Terms & Conditions</a>
          </li>-->
        </ul>
      </li>

      <li class="main-list">
        <h2 class="list-header">
          Legal
          <i class="fas fa-caret-down"></i>
        </h2>
        <ul class="sub-menu">
          <li>
            <a href="https://mtradeasia.com/legal/privacy-notice" target="_blank">Privacy Notice</a>
          </li>

          <li>
            <router-link :to="'/legal/securityalert'">Security Alert</router-link>
          </li>
        </ul>
      </li>

      <li class="main-list">
        <h2 class="list-header">
          FAQs
          <i class="fas fa-caret-down"></i>
        </h2>
        <ul class="sub-menu">
          <li>
            <router-link :to="'/faq/personal'">Personal Payments</router-link>
            <!-- <a href="">Personal Payments</a> -->
          </li>
          <li>
            <router-link :to="'/faq/business'">Business Payments</router-link>
            <!-- <a href="">Business Payments</a> -->
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {};
</script>
